import React from 'react';
import classNames from 'classnames';

import Select from '../../components/select';
import TranslationIds from '../../../commons/translationIds';
 
const defaultValue = '-';

function translateWithValue (text, v) {
    return text.replace(/{parentConsentAge}/g, v);
}

function renderParentalConsent (p) {
    const {
        fields,
        fieldErrors,
        setSubscribersFields,
        classes,
        subscribersFields,
        translate,
        widget,
        touched,
    } = p;

    if (!fields || (!fields.parentalConsentAge)) {
        return (<React.Fragment></React.Fragment>);
    }
    
    function getLabel () {
        const v = `${widget.parentalConsentValue}`
        const translation = translate(TranslationIds.REGISTRATION_VALID_PARENT_CONSENT_LABEL);
        const t = translateWithValue(translation, v);
        if (fields.parentalConsentAge && fields.parentalConsentAge === 1) {
            return `${t}*`;
        }
        return `${t}`;
    }
    
    function selectionWithTranslations () {
        return [
            { value: 'yes', label: translate(TranslationIds.REGISTRATION_YES), code: 'yes' },
            { value: 'no', label: translate(TranslationIds.REGISTRATION_NO), code: 'no' },
        ];
    }

    function getHelperText () {
        if (fieldErrors.parentConsentOn) {
            return translate(TranslationIds.REGISTRATION_VALID_PARENT_CONSENT);
        }
        return '';
    }
 
    function getValue () {
        if (!subscribersFields.parentConsentOn) {
            return defaultValue;
        }
        return subscribersFields.parentConsentOn;
    }

    function getData () {
        if (!touched.parentConsentOn || getValue() === defaultValue) {
            return [
                { label: `${translate(TranslationIds.REGISTRATION_SELECT)}`, value: defaultValue},
                ...selectionWithTranslations(),
            ];
        }
        return selectionWithTranslations();
    }

    /*
     * parentConsentAge :  17
     * parentConsentOn: "yes"
     * requiredAge: 14
    */

    return (
        <Select
            className={classNames(['ecal-reg-field-parentconsenton', classes.selectUI])}
            placeHolder={getLabel()}
            helperText={getHelperText()}
            labelHeading={getLabel()}
            value={getValue()}
            dataProvider={getData()}
            onChange={(e, value) => {
                setSubscribersFields({
                    parentConsentOn: value,
                });
            }}
            name={'parental-consent'}
            error={fieldErrors.parentConsentOn}
        />
    );
}

export default renderParentalConsent;